import Reveal from "@/components/Reveal";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

/**
 * Reusable FAQ section — matches the site design language used on
 * the Custom Home Builder Tahlequah page.
 *
 * Renders visible Q/A in the DOM AND emits FAQPage JSON-LD so search
 * engines can pick up the structured content.
 */
export default function FaqSection({ overline, headingLead, headingItalic, items, testId }) {
    return (
        <section
            className="py-24 md:py-32 px-6 md:px-10"
            style={{ background: "var(--hh-bg-2)" }}
            data-testid={testId || "faq-section"}
        >
            <div className="max-w-[1100px] mx-auto">
                <Reveal>
                    {overline && <div className="overline mb-5">{overline}</div>}
                    <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight">
                        {headingLead}{" "}
                        {headingItalic && (
                            <span style={{ fontStyle: "italic", color: "var(--hh-gold)" }}>
                                {headingItalic}
                            </span>
                        )}
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-12">
                        {items.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b"
                                style={{ borderColor: "var(--hh-border)" }}
                            >
                                <AccordionTrigger className="font-display text-xl md:text-2xl text-left py-6 hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    className="text-base leading-relaxed pb-6"
                                    style={{ color: "var(--hh-text-dim)" }}
                                >
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
